import React, { useEffect, useState } from "react";
import {
  Box,
  CssBaseline,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ButtonGroup,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
import api from "../../api/axiosInstance"
import AppBarComponent from "../../components/layout/AppbarComponent";
import { manhourCalculator } from "../../utils/manhourCalculator";
import { ToastContainer, toast } from "react-toastify";
import { useConfirm } from "../../utils/useConfirm";

export default function EstimateManhour() {
  const { id } = useParams(); // software_id
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;
  const { confirm } = useConfirm();

  const [softwareData, setSoftwareData] = useState({});
  const [fetchData, setFetchData] = useState([]);
  const [functions, setFunctions] = useState([]);

  // Load all functions (not group by UC)
  useEffect(() => {
    const loadFunctions = async () => {
      try {
        const res = await api.get(`api/func/getfunctions/${id}`);
        const data = res.data.map((f) => ({
          ...f,
          manhours:
            Number(f.manhours) > 0
              ? Number(f.manhours)
              : manhourCalculator(f.function_type, f.function_complexity),
        }));

        setFunctions(data);
        setFetchData(JSON.parse(JSON.stringify(data)));
      } catch (err) {
        console.error(err);
      }
    };

    const loadSoftwareData = async () => {
      try {
        const res = await api.get(`api/software/getsoftware/${id}`);
        setSoftwareData(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    loadSoftwareData();
    loadFunctions();
  }, [id, API_URL]);

  const handleChange = (index, e) => {
    const { name, value } = e.target;

    const updated = [...functions];
    updated[index][name] = value;

    setFunctions(updated);
  };

  const handleSave = async () => {
    try {
      await api.post(`api/func/manhours`, {
        software_id: id,
        dev_manhours: functions.reduce(
          (total, fn) => total + Number(fn.manhours || 0),
          0
        ),
        functions,
      });

      setFetchData(JSON.parse(JSON.stringify(functions)));
      toast.success("บันทึก Manhour สำเร็จ");
    } catch (err) {
      console.error(err);
      toast.error("บันทึกไม่สำเร็จ");
    }
  };

  const handleBack = async () => {
    const hasChanges = JSON.stringify(fetchData) !== JSON.stringify(functions);
    if (hasChanges) {
      const ok = await confirm(
        "คุณยังไม่ได้บันทึกการเปลี่ยนแปลง ต้องการดำเนินการต่อหรือไม่?"
      );
      if (!ok) return;
    }
    navigate(`/software/addfunction/${id}`);
  };

  const handleNext = async () => {
    const hasChanges = JSON.stringify(fetchData) !== JSON.stringify(functions);
    if (hasChanges) {
      const ok = await confirm(
        "คุณยังไม่ได้บันทึกการเปลี่ยนแปลง ต้องการดำเนินการต่อหรือไม่?"
      );
      if (!ok) return;
    }
    navigate(`/summarycost/${id}`);
  };

  return (
    <>
      <CssBaseline />
      <AppBarComponent />
      <ToastContainer position="top-center" autoClose={2000} />

      <Box sx={{ p: 2, backgroundColor: "#DFF6F0", minHeight: "100vh" }}>
        <Paper sx={{ width: "95%", m: "0 auto", p: 3 }}>
          <Typography variant="h6" mb={2} sx={{ fontWeight: "bold" }}>
            ประเมินค่าความพยายาม (Man-Hour) สำหรับโครงการ : 
          </Typography>
          <Typography variant="h6" mb={2} sx={{ fontWeight: "bold" }}>
            {id}{"_"}
            {softwareData.software_name ? softwareData.software_name : ""}
          </Typography>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Function Name
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>ประเภท</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>ความซับซ้อน</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>ค่าความพยายาม (Man-hour)</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {functions.map((fn, index) => (
                  <TableRow key={fn.function_id}>
                    <TableCell>{fn.function_name}</TableCell>
                    <TableCell>{fn.function_type}</TableCell>
                    <TableCell>{fn.function_complexity}</TableCell>

                    <TableCell>
                      <TextField
                        type="number"
                        name="manhours"
                        value={fn.manhours}
                        onChange={(e) => handleChange(index, e)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell
                    colSpan={3}
                    align="right"
                    sx={{ fontWeight: "bold" }}
                  >
                    รวม Manhour ทั้งหมด:
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    {functions.reduce(
                      (total, fn) => total + Number(fn.manhours || 0),
                      0
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Box display="flex" justifyContent="space-between" mt={2}>
            <Button
              variant="contained"
              color="success"
              onClick={handleSave}
              sx={{ fontWeight: "bold" }}
            >
              บันทึก
            </Button>

            <ButtonGroup>
              <Button
                variant="contained"
                color="inherit"
                onClick={handleBack}
                sx={{ fontWeight: "bold" }}
              >
                ย้อนกลับ
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                sx={{ fontWeight: "bold" }}
              >
                ถัดไป
              </Button>
            </ButtonGroup>
          </Box>
        </Paper>
      </Box>
    </>
  );
}
